module.exports = "<div class=\"day-weekday\" ng-bind=\"::day.dayOfWeek.substr(0, 3)\"></div>\n<div class=\"day-date\">\n    <span ng-bind=\"::day.$formatted.month + ' '\"></span>\n    <span ng-bind=\"::day.$formatted.dayDate\"></span>\n</div>\n<div class=\"flex-row day-header-total\">\n    <span class=\"day-hours\" ng-bind=\"Timesheets.getDayHours(day)\" xbind-refresh-when=\"['$refresh:day', '$refresh:hours', '$refresh:timesheet']\"></span>\n    <span class=\"day-hours-label\">Hours</span>\n    <span class=\"day-hours-label-mini\">Hrs</span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/directives/day-header/day-header.html
// module id = 448
// module chunks = 22